<template>
  <div class="web">
    <div class="pc-box">
      <!-- 头部导航 -->
      <div class="pc-header">
        <div class="pc-header-auto">
          <div class="header-left">
            <img src="@/assets/logo.png" class="brand-logo" @click="$router.push('/venueDetail-pc')">
            <span class="page-indicator">预约列表</span>
          </div>
          <div class="header-right">
            <a-button type="link" @click="$router.push('/venueDetail-pc')">返回首页</a-button>
          </div>
        </div>
      </div>

      <!-- 内容主体 -->
      <div class="pc-content-wrapper">
        <div class="pc-content-inner">
          <!-- 面包屑 -->
          <a-breadcrumb class="custom-breadcrumb">
            <a-breadcrumb-item>预约列表</a-breadcrumb-item>
          </a-breadcrumb>

          <!-- 订单状态筛选 -->
          <div class="status-tabs-pc">
            <a-tabs v-model="queryParams.status" @change="tabChange" :tabBarStyle="{ marginBottom: '24px' }">
              <a-tab-pane tab="全部" key="" />
              <a-tab-pane v-for="(item) in orderStatusOptions" v-if="!['0','5','6'].includes(item.value)" :tab="item.label" :key="item.value" />
            </a-tabs>
          </div>

          <!-- 订单表格 -->
          <div class="order-table-section">
            <a-card :bordered="false" class="table-card">
              <a-table
                :columns="columns"
                :data-source="data.records"
                :loading="data.loading"
                :pagination="false"
                rowKey="id"
              >
                <!-- 订单编号列 -->
                <span slot="orderNo" slot-scope="text, record">
                  <a @click="toDetail(record)">{{ text }}</a>
                </span>

                <!-- 场馆信息列 -->
                <span slot="groundName" slot-scope="text">
                  <a-icon type="environment" style="margin-right: 4px; color: #883032;" />
                  {{ text }}
                </span>

                <!-- 运动类型列 -->
                <span slot="sportType" slot-scope="text">
                  <a-tag color="blue">{{ getDictName(sportTypeList, text) }}</a-tag>
                </span>

                <!-- 金额列 -->
                <span slot="totalAmount" slot-scope="text">
                  <span class="amount-text">￥{{ text }}</span>
                </span>

                <!-- 状态列 -->
                <span slot="status" slot-scope="text">
                  <a-tag :color="getStatusColor(text)">{{ getDictName(orderStatusOptions, text) }}</a-tag>
                </span>

                <!-- 操作列 -->
                <span slot="action" slot-scope="text, record">
                  <div class="action-buttons">
                    <a-button type="link" size="small" @click="toDetail(record)">详情</a-button>
                    <a-button
                      v-if="record.status === '0' && record.hasService === '1'"
                      type="link"
                      size="small"
                      @click="openService(record)"
                    >修改服务</a-button>
                    <a-button
                      v-if="record.status === '0' || record.status === '1'"
                      type="link"
                      size="small"
                      style="color: #ff4d4f;"
                      @click="cancelReservation(record)"
                    >取消预约</a-button>
                    <a-button
                      v-if="record.status === '0'"
                      type="primary"
                      size="small"
                      @click="$refs.campusCardPay.show(record)"
                    >立即支付</a-button>
                    <a-button
                      v-if="record.status === '2'"
                      type="primary"
                      size="small"
                      @click="toEvaluate(record)"
                    >评价</a-button>
                  </div>
                </span>
              </a-table>

              <!-- 分页器 -->
              <div class="pagination-wrapper">
                <a-pagination
                  v-model="data.current"
                  :total="data.total"
                  :pageSize="data.size"
                  show-quick-jumper
                  @change="handlePageChange"
                />
              </div>
            </a-card>
          </div>
        </div>
      </div>

      <!-- 页脚 -->
      <div class="pc-footer">
        <div class="footer-content">
          <p>智慧能源创新学院 场馆预约系统</p>
          <p class="copyright">Copyright © www.senergy.sjtu.edu.cn. All Rights Reserved</p>
        </div>
      </div>
    </div>

    <!-- 弹窗组件 -->
    <service-cart-pc ref="serviceCart" @handleOk="handleServiceOk" />
    <campus-card-payment ref="campusCardPay" @refresh="refresh" />
  </div>
</template>

<script>
import { queryList, cancel, updateService } from '@/api/order/order'
import { getDictByType } from '@/api/common'
import { getDictName } from '@/utils/common'
import ServiceCartPc from '@/views/components/ServiceCartPc'
import CampusCardPayment from '@/views/order/components/CampusCardPayment'
import moment from 'moment'
import {
  Button, Breadcrumb, Tabs, Table, Tag, Card, Pagination, Icon, Modal, message
} from 'ant-design-vue'

export default {
  name: 'OrderIndexPc',
  components: {
    ServiceCartPc,
    CampusCardPayment,
    'a-button': Button,
    'a-breadcrumb': Breadcrumb,
    'a-breadcrumb-item': Breadcrumb.Item,
    'a-tabs': Tabs,
    'a-tab-pane': Tabs.TabPane,
    'a-table': Table,
    'a-tag': Tag,
    'a-card': Card,
    'a-pagination': Pagination,
    'a-icon': Icon
  },
  data() {
    return {
      getDictName,
      queryParams: {
        status: ''
      },
      orderStatusOptions: [],
      sportTypeList: [],
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        loading: false
      },
      selectOrder: {},
      columns: [
        { title: '订单编号', dataIndex: 'orderNo', key: 'orderNo', scopedSlots: { customRender: 'orderNo' } },
        { title: '场馆名称', dataIndex: 'groundName', key: 'groundName', scopedSlots: { customRender: 'groundName' } },
        { title: '项目类型', dataIndex: 'sportType', key: 'sportType', scopedSlots: { customRender: 'sportType' } },
        { title: '预约时间', dataIndex: 'createTime', key: 'createTime' },
        // { title: '订单金额', dataIndex: 'totalAmount', key: 'totalAmount', scopedSlots: { customRender: 'totalAmount' } },
        { title: '状态', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 220 }
      ]
    }
  },
  created() {
    this.initDicts()
    this.refresh()
  },
  methods: {
    initDicts() {
      getDictByType('sport_type').then(res => {
        if (res.result) {
          this.sportTypeList = res.result.map(item => ({ label: item.dictKey, value: item.dictValue }))
        }
      })
      getDictByType('order_status').then(res => {
        if (res.code === 10000) {
          this.orderStatusOptions = res.result.map(item => ({ label: item.dictKey, value: item.dictValue }))
        }
      })
    },
    refresh() {
      this.getList()
    },
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      const params = {
        ...this.queryParams,
        current: this.data.current,
        size: this.data.size
      }
      queryList(params).then(res => {
        if (res.code === 10000) {
          this.data.records = res.result.records
          this.data.total = res.result.total
        }
      }).finally(() => {
        this.data.loading = false
      })
    },
    tabChange() {
      this.data.current = 1
      this.refresh()
    },
    handlePageChange(page) {
      this.data.current = page
      this.refresh()
    },
    getStatusColor(status) {
      const colorMap = { '0': 'orange', '1': 'blue', '2': 'green', '3': 'cyan', '4': 'gray' }
      return colorMap[status] || 'default'
    },
    toDetail(record) {
      this.$router.push({ path: '/orderDetail-pc', query: { id: record.id } })
    },
    toEvaluate(record) {
      this.$router.push({ path: '/order/evaluate', query: { id: record.id } })
    },
    openService(record) {
      this.selectOrder = record
      this.$refs.serviceCart.show(record.serviceList)
    },
    handleServiceOk(services) {
      if (services.length === 0) {
        message.warning('请选择服务')
        return
      }
      const data = {
        id: this.selectOrder.id,
        serviceList: services
      }
      updateService(data).then(res => {
        if (res.code === 10000) {
          message.success('更新服务成功')
          this.refresh()
        }
      })
    },
    cancelReservation(record) {
      let msg = '确定要取消此预约吗？'


      Modal.confirm({
        title: '取消预约',
        content: msg,
        okText: '确定取消',
        cancelText: '点错了',
        onOk: () => {
          return cancel({ id: record.id }).then(res => {
            if (res.code === 10000) {
              message.success(res.result || '取消成功')
              this.refresh()
            } else {
              message.error(res.result || '取消失败')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.web {
  background: #f4f7f9;
  min-height: 100vh;
}
.pc-header {
  background: #fff;
  height: 72px;
  display: flex;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  position: sticky;
  top: 0;
  z-index: 100;
}
.pc-header-auto {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.brand-logo {
  height: 36px;
  cursor: pointer;
  margin-right: 24px;
}
.page-indicator {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-left: 2px solid #e8e8e8;
  padding-left: 24px;
}
.pc-content-wrapper {
  padding: 32px 0 64px;
}
.pc-content-inner {
  width: 1200px;
  margin: 0 auto;
}
.custom-breadcrumb {
  margin-bottom: 24px;
}
.table-card {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
}
.amount-text {
  color: #883032;
  font-weight: bold;
  font-size: 16px;
}
.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}
.pagination-wrapper {
  margin-top: 32px;
  display: flex;
  justify-content: flex-end;
}
.pc-footer {
  background: #fff;
  padding: 48px 0;
  border-top: 1px solid #e8e8e8;
}
.footer-content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: #666;
}
.copyright {
  color: #999;
  font-size: 13px;
  margin-top: 8px;
}
</style>
